import { render } from "./SalesPost.vue?vue&type=template&id=e376328e&scoped=true"
import script from "./SalesPost.vue?vue&type=script&lang=js"
export * from "./SalesPost.vue?vue&type=script&lang=js"

import "./SalesPost.vue?vue&type=style&index=0&id=e376328e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e376328e"]])

export default __exports__